// @flow
import { useEffect } from 'react';

export const DEFAULT_PAGE_TITLE = 'Ink';

const usePageTitle = (title?: ?string): void => {
  useEffect(() => {
    if (typeof title !== 'string' || title.trim().length === 0) {
      return undefined;
    }

    const nextTitle = title.trim();
    const previousTitle = document.title;
    document.title = nextTitle;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;
